






















import {Component, Prop, Vue} from 'vue-property-decorator'
import {PropertyUpsertForm} from "@/form/TmodelForm";
import DataSpecsFormItems from "@/component/Thing/data-specs-form-items.vue";
import {RwFlag} from '@/model/ThingModel';

@Component({
  components: {
    DataSpecsFormItems
  },
})
export default class PropertyUpsertFormItems extends Vue {
  @Prop()
  private upsertForm!: PropertyUpsertForm

  private RwFlag = RwFlag
}
